import { Injectable } from '@angular/core';
import { HttpService } from '../shared/http-serice.service';
import { Helper } from '../../helpers/Helper';

const helper = new Helper();
@Injectable({
  providedIn: 'root',
})
export class SidebarMenuService {
  isSidebarClosed: boolean = false;

  constructor(private httpService: HttpService) {}

  getSidebarMenus(data: any) {
    return this.httpService.get(
      `api/v1/menus?${helper.buildURLSearchParams(data)}`
    );
  }

  toggleSidebar() {
    this.isSidebarClosed = !this.isSidebarClosed; // Toggle the sidebar state
    const sidebar = document.querySelector('.sidebar') as HTMLElement;
    sidebar.classList.toggle('close');
  }

  getSidebarClosedStatus() {
    return this.isSidebarClosed;
  }
}
